module.exports = __webpack_public_path__ + "static/web-design-9b0a8a5849a97e508cb6d156a4043574.png";